import { GuardResult, MaybeAsync, RedirectCommand, Router } from "@angular/router";
import { inject } from "@angular/core";
import { QueryClient } from "@tanstack/angular-query-experimental";
import { CheckClientService, ClientCheck } from "../shared";

export function unsupportedAppVersionGuard(): MaybeAsync<GuardResult> {
	const router = inject(Router);

	return (
		inject(QueryClient)
			.fetchQuery(inject(CheckClientService).clientCheckQueryOptions())
			// Don't block the app if this version check call would fail!
			.catch<ClientCheck>(() => ({ data: { clientVersion: { active: true } } }))
			.then(
				({ data: { clientVersion } }) =>
					clientVersion?.active || new RedirectCommand(router.parseUrl("/auth/unsupported-app-version")),
			)
	);
}
